export const productsSortSelectDic = [
	{
		title: 'Сначала дешевле',
		value: '1'
	},
	{
		title: 'Сначала дороже',
		value: '2'
	},
	{
		title: 'По названию',
		value: '3'
	},
];